// src/components/BoardOfEd/components/Program2300.jsx
import React from "react";
import { ProgramBudget } from "../../../../budget/model/program/ProgramBudget.jsx";

export const PROGRAM_2300_CONFIG = {
  fullName: "PROGRAM & STAFF DEVELOPMENT",
  docId: "2300",

  fieldDefs: [
    // ===== PROGRAM DEVELOPMENT =====
    {
      key: "progCurriculumDev",
      label: "Curriculum Development",
      valueType: "currency",
      sources: [{ block: "Program Development", key: "Curriculum Development" }],
      group: "program Development",
      defaultVisible: false,
    },
    {
      key: "progTestScoring",
      label: "Test Scoring",
      valueType: "currency",
      sources: [{ block: "Program Development", key: "Test Scoring" }],
      group: "program Development",
      defaultVisible: false,
    },
    {
      key: "progTestingSupplies",
      label: "Testing Supplies",
      valueType: "currency",
      sources: [{ block: "Program Development", key: "Testing Supplies" }],
      group: "program Development",
      defaultVisible: false,
    },
    {
      key: "progSupplies",
      label: "Supplies / Instructional Supplies",
      valueType: "currency",
      sources: [
        { block: "Program Development", key: "Instructional Supplies" },
        { block: "Program Development", key: "Supplies" },
      ],
      group: "program Development",
      defaultVisible: false,
    },
    {
      key: "progRecruitment",
      label: "Recruitment",
      valueType: "currency",
      sources: [{ block: "Program Development", key: "Recruitment" }],
      group: "program Development",
      defaultVisible: false,
    },

    // ===== STAFF DEVELOPMENT (CONSOLIDATED) =====
    {
      key: "sdProfMtgsAdmins",
      label: "Prof. Mtgs., Administrators",
      valueType: "currency",
      sources: [{ block: "Staff Development", key: "Prof. Mtgs., Administrators" }],
      group: "staff Development",
      defaultVisible: false,
    },
    {
      key: "sdProfMtgsCertified",
      label: "Prof. Mtgs., Certified",
      valueType: "currency",
      sources: [{ block: "Staff Development", key: "Prof. Mtgs., Certified" }],
      group: "staff Development",
      defaultVisible: false,
    },
    {
      key: "sdProfMtgsClassified",
      label: "Prof. Mtgs., Classified",
      valueType: "currency",
      sources: [{ block: "Staff Development", key: "Prof. Mtgs., Classified" }],
      group: "staff Development",
      defaultVisible: false,
    },
    {
      key: "sdTeachersCollege",
      label: "Teachers College Project",
      valueType: "currency",
      sources: [{ block: "Staff Development", key: "Teachers College Project" }],
      group: "staff Development",
      defaultVisible: false,
    },
    {
      key: "sdProfessionalDues",
      label: "Professional Dues",
      valueType: "currency",
      sources: [{ block: "Staff Development", key: "Professional Dues" }],
      group: "staff Development",
      defaultVisible: false,
    },
    {
      key: "sdTuitionTeachers",
      label: "Tuition Reim.-Teachers",
      valueType: "currency",
      sources: [{ block: "Staff Development", key: "Tuition Reim.-Teachers" }],
      group: "staff Development",
      defaultVisible: false,
    },
    {
      key: "sdTuitionAdmins",
      label: "Tuition Reim.-Admins.",
      valueType: "currency",
      sources: [{ block: "Staff Development", key: "Tuition Reim.-Admins." }],
      group: "staff Development",
      defaultVisible: false,
    },
    {
      key: "sdTuitionSecyPara",
      label: "Tuition Reim.-Secy/Para/Non-Contract",
      valueType: "currency",
      sources: [{
        block: "Staff Development",
        key: "Tuition Reim.-Secy/Para/Non-Contract",
      }],
      group: "staff Development",
      defaultVisible: false,
    },

    // ===== OTHER =====
    {
      key: "otherPublications",
      label: "Publications",
      valueType: "currency",
      sources: [{ block: "Other", key: "Publications" }],
      group: "other",
      defaultVisible: false,
    },
  ],

  tables: [
    {
      id: "approved",
      title: "Approved Budget",
      sectionKey: "Approved",
      fields: [
        "progCurriculumDev",
        "progTestScoring",
        "progTestingSupplies",
        "progSupplies",
        "progRecruitment",

        "sdProfMtgsAdmins",
        "sdProfMtgsCertified",
        "sdProfMtgsClassified",
        "sdTeachersCollege",
        "sdProfessionalDues",
        "sdTuitionTeachers",
        "sdTuitionAdmins",
        "sdTuitionSecyPara",

        "otherPublications",
      ],
    },
    {
      id: "actual",
      title: "Actual Spending",
      sectionKey: "Actual",
      fields: [
        "progCurriculumDev",
        "progTestScoring",
        "progTestingSupplies",
        "progSupplies",
        "progRecruitment",

        "sdProfMtgsAdmins",
        "sdProfMtgsCertified",
        "sdProfMtgsClassified",
        "sdTeachersCollege",
        "sdProfessionalDues",
        "sdTuitionTeachers",
        "sdTuitionAdmins",
        "sdTuitionSecyPara",

        "otherPublications",
      ],
    },
  ],
};

export function Program2300(props) {
  return (
    <ProgramBudget programId="2300" config={PROGRAM_2300_CONFIG} {...props} />
  );
}
